import { Box, CloseButton, Drawer, Stack, Tabs, Text } from "@mantine/core";
import { FC, useState } from "react";
import { ReactComponent as FunnelIcon } from "assets/funnel.svg";
import { ReactComponent as PalleteIcon } from "assets/Palette.svg";
import ColorsPanel, { ColorType } from "./ColorsPanel";
import FiltersPanel, { FilterControl } from "./FiltersPanel";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilter: (f: FilterControl) => void;
  onApplyColor: (c?: ColorType) => void;
  initFilterControl?: FilterControl;
  initColor?: ColorType;
}

type TabTypes = "filters" | "colors";

const FunnelModal: FC<Props> = ({ 
  isOpen, 
  onClose, 
  onApplyFilter, 
  onApplyColor,
  initFilterControl, 
  initColor 
}) => {
  const [activeTab, setActiveTab] = useState<TabTypes>("colors");

  return (
    <Drawer
      opened={isOpen}
      zIndex={5001}
      size="xl"
      radius="30px 30px 0 0"
      onClose={() => {
        onClose();
      }}
      position="bottom"
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      <Box
        p={0}
        pt={40}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
        <Box
          c="#4F7D9C"
          fz="h3"
          fw="bold"
          pos="absolute"
          top={20}
          left={10}>
          Map Visualization
        </Box>
        <CloseButton
          size="xl"
          pos="absolute"
          top={10}
          right={-10}
          onClick={() => {
            onClose();
          }}
        />
        <Box pt="xl" style={{ position: "relative", boxSizing: "border-box", height: "100%"}}>
          <Tabs
            color="#4F7D9C"
            style={{
              boxSizing: "border-box",
              height: "90%",
              position: "relative"
            }}
            value={activeTab}
            onChange={(t) => {
              if (t) {
                setActiveTab(t as TabTypes);
              }
            }}>
            <Tabs.List>
              <Tabs.Tab value="colors">
                <Stack align="center" c={activeTab === "colors" ? "#4F7D9C" : "dimmed"}>
                  <PalleteIcon style={{ transform: "scale(1.0)" }} />
                  <Text mt={-10} fz="xs" fw="bold">Colors</Text>
                </Stack>
              </Tabs.Tab>
              <Tabs.Tab value="filters">
                <Stack align="center" c={activeTab === "filters" ? "#4F7D9C" : "dimmed"}>
                  <FunnelIcon style={{ transform: "scale(1.0)" }} />
                  <Text mt={-10} fz="xs" fw="bold">Filters</Text>
                </Stack>
              </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="colors" h="100%">
              <ColorsPanel
                initColor={initColor}
                onApplyColor={(c) => {
                  onApplyColor(c);
                  onClose();
                }}
                onClose={() => {
                  onClose()
                }}
               />
            </Tabs.Panel>
            <Tabs.Panel value="filters" h="100%">
              <FiltersPanel
                initFilterControl={initFilterControl}
                colorControl={initColor}
                onApplyFilter={(f) => {
                  onApplyFilter(f)
                }}
                onClose={() => {
                  onClose();
                }}
               />
            </Tabs.Panel>
          </Tabs>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FunnelModal;